import React, { useState } from 'react';
import FilterButton from './FilterButton';
import FilterBar, { FilterAction } from './FilterBar';
import '../styles/components/SearchFilterControl.css';
import { ResourceFilterConfig } from '../types/filterTypes';

interface SearchFilterControlProps {
  // Content
  searchQuery?: string;
  filters?: Record<string, any>;
  
  // Filter configuration
  filterConfig: ResourceFilterConfig;
  
  // Visibility options
  showSearch?: boolean;
  showFilterButton?: boolean;
  showFilterBar?: boolean;
  
  // Event handlers
  onSearchChange?: (value: string) => void;
  onSearchSubmit?: (e: React.FormEvent) => void;
  onFilterChange?: (filters: Record<string, any>) => void;
  onFilterActionChange?: (action: FilterAction) => void;
  
  // Placeholder
  searchPlaceholder?: string;
  
  // Additional styling
  className?: string;
}

const SearchFilterControl: React.FC<SearchFilterControlProps> = ({
  searchQuery = '',
  filters = {},
  filterConfig,
  
  showSearch = true,
  showFilterButton = true,
  showFilterBar = true,
  
  onSearchChange,
  onSearchSubmit,
  onFilterChange,
  onFilterActionChange,
  
  searchPlaceholder = 'Search',
  className = ''
}) => {
  // Local state to manage the search value if not controlled externally
  const [localSearchQuery, setLocalSearchQuery] = useState(searchQuery);
  
  // Handle search input change
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearchQuery(value);
    if (onSearchChange) onSearchChange(value);
  };
  
  // Handle search form submission
  const handleSearchSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSearchSubmit) onSearchSubmit(e);
  };
  
  return (
    <div className={`search-filter-control ${className}`}>
      <div className="search-filter-header">
        {showSearch && (
          <form onSubmit={handleSearchSubmit} className="search-form">
            <input 
              type="text"
              placeholder={searchPlaceholder || `Search ${filterConfig.resourceName}`}
              value={onSearchChange ? searchQuery : localSearchQuery}
              onChange={handleSearchChange}
              className="search-input"
            />
            <button type="submit" className="search-button">
              <span className="material-icons">search</span>
            </button>
          </form>
        )}
        
        {showFilterButton && (
          <FilterButton 
            filters={filters}
            filterConfig={filterConfig}
            onFilterChange={onFilterChange || (() => {})}
          />
        )}
      </div>
      
      {showFilterBar && (
        <div className="filter-bar-container">
          <FilterBar 
            filters={filters}
            filterConfig={filterConfig}
            onFilterChange={onFilterActionChange || (() => {})}
          />
        </div>
      )}
    </div>
  );
};

export default SearchFilterControl; 